export const convertDataModelToContent = <T>(model: Record<string, T>): (T & { id: string })[] => {
  return Object.entries(model).map(([key, item]) => ({ id: key, ...item }));
};
